<template>
  <section>
    <search-title-parts
      :type="type"
    />
    <div class="cont_box">
      <search-form-pane
        :type="type"
        :search="search"
        :bikeList="bikeList"
        :selectedBikes="tempSelectedNames"
        @changeDisplacement="changeDisplacement"
        @changeMileage="changeMileage"
        @changeShop="changeShop"
        @changePriceMin="changePriceMin"
        @changePriceMax="changePriceMax"
        @updateBikeCheck="updateBikeCheck"
        @reset="reset"
      />

      <search-result-pane
        :type="type"
        :searchResult="searchResult"
        :banner="banner"
        :sortValue="sortValue"
        :sortDirection="sortDirection"
        @moreLoad="moreLoad"
        @sortChange="changeSort"
      />
    </div>

    <search-loader-parts
      :enabledLoader="loading"
    />
  </section>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import axios from 'axios'
import dayjs from 'dayjs'
import { Util } from './master.js'
import SearchFormPane from './LineupSearch/SearchFormPane.vue'
import SearchResultPane from './LineupSearch/SearchResultPane.vue'
import SearchTitleParts from './parts/SearchTitleParts.vue'
import SearchLoaderParts from './parts/SearchLoaderParts.vue'

export default defineComponent({
  name: 'lineupSearch',
  components: {
    SearchLoaderParts,
    SearchFormPane,
    SearchResultPane,
    SearchTitleParts
  },
  props: {
    type: {
      type: String,
      default: 'new'
    },
    banner: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const typeID = computed(() => Util.TYPE_ID[props.type])
    const { DEALER } = Util

    const
      sortValue = ref('created'),
      sortDirection = ref('desc'),
      loading = ref(true),
      page = ref(1),
      search = ref({
        word: '',
        price_from: 0,
        price_to: 0,
        displacement: '',
        mileage: '',
        dealer: '0',
        dealerVal: '0'
      }),
      resultNum = ref(0),
      bikeList = ref([]),
      selectedProductNames = ref([]),
      tempSelectedNames = ref([]),
      searchResult = ref({
        data: [],
        pagination: {
          count: 0,
          current_page: 1,
          has_next_page: false,
          has_prev_page: false,
          limit: null,
          page_count: 1
        }
      })

    return {
      DEALER,
      typeID,
      search,
      sortValue,
      sortDirection,
      loading,
      resultNum,
      searchResult,
      bikeList,
      selectedProductNames,
      tempSelectedNames,
      page,
      DISPLACEMENT: Util.DISPLACEMENT,
      MILEAGE: Util.MILEAGE
    }
  },
  async mounted() {
    let tempRead = false
    // const tempQuery = window.localStorage.getItem(`search-temp-${this.type}`)
    const tempData = await this.getFiltersFromURL()
    this.search = tempData
    // if (tempQuery) {
    //   const tempData = JSON.parse(tempQuery)
    //   if (tempData.time > dayjs().unix() - 300) {
    //     tempRead = true
    //     this.search = tempData.query
    //   }
    // }

    await this.searchBikeList(true, true)
    let initialItemCount = null

    // if (tempRead) {
    //   const tempData = await JSON.parse(tempQuery)
    //   initialItemCount = Number(tempData.page) > 1 ? Number(tempData.page) * Util.SEARCH_LIMIT : Util.SEARCH_LIMIT
    //   this.selectedProductNames = tempData.selectedProductNames ? tempData.selectedProductNames : []
    //   this.tempSelectedNames = tempData.selectedProductNames ? tempData.selectedProductNames : []
    // }

    if (tempData) {
      initialItemCount = Util.SEARCH_LIMIT
      this.selectedProductNames = tempData['product_names'] ? tempData['product_names'] : []
      this.tempSelectedNames = tempData['product_names'] ? tempData['product_names'] : []
    }

    await this.searchBikes(true, false, initialItemCount)

    // if (tempRead) {
    //   const tempData = await JSON.parse(tempQuery)
    //   this.page = tempData.page ? tempData.page : 1
    //
    //   this.scrollAfterLoading()
    // }
  },
  methods: {
    /**
     * リセット処理(暫定でリロード)
     */
    reset() {
      window.localStorage.removeItem(`search-temp-${this.type}`)
      this.loading = true
      window.location = './'
    },
    /**
     * 追加読み込み
     */
    moreLoad() {
      this.page++
      const searchTemp = {
        time: dayjs().unix(),
        query: this.search,
        selectedProductNames: this.selectedProductNames,
        page: this.page
      }
      window.localStorage.setItem(`search-temp-${this.type}`, JSON.stringify(searchTemp))
      this.searchBikes(true, true)
    },
    /**
     * 排気量指定を変更
     * @param val Number
     */
    async changeDisplacement(val) {
      this.search.displacement = val
      this.selectedProductNames = []
      this.tempSelectedNames = []
      await this.allSearch()
    },
    /**
     * 走行距離指定を変更
     * @param val Number
     */
    async changeMileage(val) {
      this.search.mileage = val
      this.selectedProductNames = []
      this.tempSelectedNames = []
      await this.allSearch()
    },
    /**
     * 店舗指定を変更
     * @param val Number
     */
    async changeShop(val) {
      // val の文末に all があるかチェック
      if (val.length > 3 && val.slice(-3) === 'all') {
        // valからallを取り除いてIntに変換
        let areaIndex = Number(val.slice(0, -3))
        // search.dealer.area[areaIndex].shops[] のidを全取得
        let shopIds = ''
        this.DEALER.area[areaIndex].shops.forEach((shop, i) => {
          if (i !== 0) {
            shopIds += ','
          }
          shopIds += shop.id
        })
        this.search.dealerVal = shopIds
      } else {
        this.search.dealerVal = val
      }

      this.search.dealer = val
      this.selectedProductNames = []
      this.tempSelectedNames = []
      await this.allSearch()
    },
    /**
     * 予算下限値を変更
     * @param val Number
     */
    async changePriceMin(val) {
      this.search.price_from = Number(val)
      this.selectedProductNames = []
      this.tempSelectedNames = []
      await this.allSearch()
    },
    /**
     * 予算上限値を変更
     * @param val Number
     */
    async changePriceMax(val) {
      this.search.price_to = Number(val)
      this.selectedProductNames = []
      this.tempSelectedNames = []
      await this.allSearch()
    },
    /**
     * バイクモデル選択値を変更
     * @param val String[]
     */
    async updateBikeCheck(val) {
      this.selectedProductNames = val
      await this.allSearch()
    },
    /**
     * 検索
     */
    async allSearch() {
      this.page = 1
      const searchTemp = {
        time: dayjs().unix(),
        query: this.search,
        selectedProductNames: this.selectedProductNames,
        page: this.page
      }
      window.localStorage.setItem(`search-temp-${this.type}`, JSON.stringify(searchTemp))
      await this.searchBikeList(true, true)
      await this.searchBikes(true)
    },
    /**
     * 車両一覧を取得
     * @param loader Boolean ローディングを有効化
     * @param notLoadEnd Boolean 最後にローダーを残すか
     * @returns {Promise<void>}
     */
    async searchBikeList(loader, notLoadEnd) {
      try {
        if (loader) {
          this.loading = true
        }
        const params = await this.getReqQuery('name')
        const res = await axios({
          method: 'get',
          url: Util.API.productNames,
          params,
          headers: {
            Accept: 'application/json',
            'Content-type': 'application/json'
          }
        })
        // ソートして代入
        const collator = new Intl.Collator('ja')
        const temp = res.data.data.sort(collator.compare)
        this.bikeList = temp
        if (loader && !notLoadEnd) {
          this.loading = false
        }
      } catch (e) {
        console.error(e)
        this.bikeList = []
        if (loader) {
          this.loading = false
        }
      }
    },
    /**
     * 検索取得
     * @param loader Boolean ローディングを有効化
     * @param more Boolean ページネーションの更に読み込みの場合
     * @param initialItemCount Number 読込数指定
     * @returns {Promise<void>}
     */
    async searchBikes(loader, more, initialItemCount) {
      try {
        if (loader) {
          this.loading = true
        }
        const params = await this.getReqQuery('product', initialItemCount)
        await axios({
          method: 'get',
          url: Util.API.products,
          params,
          headers: {
            Accept: 'application/json',
            'Content-type': 'application/json'
          }
        }).then(res => {
          const response = JSON.parse(JSON.stringify(res.data))

          this.updateURL(params)
          if (more) {
            response.data.forEach(item => {
              this.searchResult.data.push(item)
            })
          } else {
            this.searchResult.data = response.data
          }

          this.searchResult.pagination = response.pagination
          if (loader) {
            this.loading = false
          }
        })
      } catch (e) {
        console.error(e)
        this.searchResult.data = []
        this.searchResult.pagination = {
          count: 0,
          current_page: 1,
          has_next_page: false,
          has_prev_page: false,
          limit: null,
          page_count: 1
        }
        if (loader) {
          this.loading = false
        }
      }
    },
    /**
     * 検索クエリを取得
     * @param type String 'product' || 'name'
     * @param initialItemCount Number || nul
     * @returns {{displacement_to: *, shop_id: (number|*), price_from: (number|null), product_names: *[], price_to: (number|null), limit: number, product_type_id: *, mileage_from: *, mileage_to: *, word: (*|null), displacement_from: *}}
     */
    getReqQuery(type, initialItemCount) {
      const
        displacement = this.DISPLACEMENT.find(item => item.value === this.search.displacement),
        mileage = this.MILEAGE.find(item => item.value === this.search.mileage)

      const
        displacement_from = displacement.from > 0 ? displacement.from : null,
        displacement_to = displacement.to > 0 ? displacement.to : null,
        mileage_from = mileage.from !== 0 ? mileage.from : null,
        mileage_to = mileage.to !== 0 ? mileage.to : null,
        shop_id = this.search.dealerVal !== '0' ? this.search.dealerVal : null,
        price_from = Number(this.search.price_from) !== 0 ? Number(this.search.price_from) : null,
        price_to = Number(this.search.price_to) !== 0 ? Number(this.search.price_to) : null,
        product_names = this.selectedProductNames.length > 0 ? this.selectedProductNames : [],
        sort = this.sortValue,
        direction = this.sortDirection

      if (type === 'product') {
        return {
          product_type_id: this.typeID,
          word: this.search.word || null,
          price_from,
          price_to,
          displacement_from,
          displacement_to,
          mileage_from,
          mileage_to,
          product_names,
          shop_id,
          sort,
          direction,
          limit: initialItemCount || Util.SEARCH_LIMIT,
          page: this.page
        }
      } else if (type === 'name') {
        return {
          product_type_id: this.typeID,
          price_from,
          price_to,
          displacement_from,
          displacement_to,
          mileage_from,
          mileage_to,
          shop_id
          // sort,
          // direction,
        }
      }
    },
    scrollAfterLoading() {
      const url = new URL(window.location.href)
      const id = url.searchParams.get('id')
      const targetElement = document.querySelector(`#id-${id}`)
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        })
      }
    },
    changeSort(sortValue, sortDirection) {
      this.sortValue = sortValue
      this.sortDirection = sortDirection
      this.page = 1
      this.searchBikes(true)
    },
    /**
     * URLを更新
     * @param params Object
     */
    updateURL(params) {
      const url = new URL(window.location)
      const newPrams = new URLSearchParams(url.search)
      newPrams.forEach((_, key) => newPrams.delete(key))

      Object.keys(params).forEach(key => {
        if (params[key] == null) {
          return
        }
        if (Array.isArray(params[key])) {
          newPrams.set(key, params[key].join(',')) // 配列はカンマ区切りに
        } else {
          newPrams.set(key, params[key])
        }
      })
      url.search = newPrams.toString()
      window.history.pushState({}, '', url)
    },
    /**
     * URLからフィルターを取得
     * @returns {Promise<void>}
     */
    async getFiltersFromURL() {
      const urlParams = new URLSearchParams(window.location.search)

      const price_to = Number(urlParams.get('price_to')) ?? this.search.price_to
      const price_from = Number(urlParams.get('price_from')) ?? this.search.price_from

      const displacementFrom = Number(urlParams.get('displacement_from') || 0)
      const displacementTo = Number(urlParams.get('displacement_to') || 0)
      let displacement = this.search.displacement
      if (displacementTo > 0) {
        Util.DISPLACEMENT.forEach(item => {
          if (item.from === displacementFrom && item.to === displacementTo) {
            displacement = item.value
          }
        })
      }

      const mileageFrom = Number(urlParams.get('mileage_from') || 0)
      const mileageTo = Number(urlParams.get('mileage_to') || 0)
      let mileage = this.search.mileage
      if (mileageFrom > 0) {
        Util.MILEAGE.forEach(item => {
          if (item.from === mileageFrom && item.to === mileageTo) {
            mileage = item.value
          }
        })
      }

      let product_names = this.search.selectedProductNames || []
      if (urlParams.get('product_names')) {
        urlParams.get('product_names').split(',').forEach(item => {
          product_names.push(String(item))
        })
      }

      this.sortValue = urlParams.get('sort') ?? this.sortValue
      this.sortDirection = urlParams.get('direction') ?? urlParams.get('direction')

      let dealer = this.search.dealer
      let dealerVal = this.search.dealerVal
      if (urlParams.get('shop_id')) {
        let parmShopId = urlParams.get('shop_id')
        dealerVal = parmShopId

        if (parmShopId.indexOf(',') !== -1) {
          let tempArea = []
          this.DEALER.area.forEach((area, i) => {
            let shopIds = ''
            tempArea.push(area)
            area.shops.forEach((shop, j) => {
              if (i !== 0) {
                shopIds += ','
              }
              shopIds += shop.id
            })
            tempArea[i].all = shopIds
          })

          let shopIds = parmShopId.split(',')
          let selectArea = tempArea.filter(area => {
            return area.shops.some(shop => shopIds.includes(String(shop.id)))
          })
          dealer = selectArea[0].allVal
        } else {
          dealer = parmShopId
        }
      }
      return {
        price_from,
        price_to,
        displacement,
        mileage,
        dealer,
        dealerVal,
        product_names
      }
    }
  }
})

</script>